import { render } from "./AllNormativeDocuments.vue?vue&type=template&id=6202d349"
import script from "./AllNormativeDocuments.vue?vue&type=script&lang=js"
export * from "./AllNormativeDocuments.vue?vue&type=script&lang=js"

import "./AllNormativeDocuments.vue?vue&type=style&index=0&id=6202d349&lang=css"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__